import("./bootstrap");

// Exportação vazia para garantir que este arquivo seja tratado como um módulo
export {}; 